import {createContext, useContext} from "react";
import {MoneyRange} from "./Types/MoneyRange";

export interface InvestAssistantContextType {
    type: string,
    newsletterConsent: boolean;
    setNewsletterConsent: (value: (((prevState: boolean) => boolean) | boolean)) => void;
    currentStageNumberToDisplay: number;
    currentStage: number;
    handleGoToStage: (stage: number) => void;
    handlePrev: (decreaseStepNumber: boolean) => void;
    handleNext: (increaseStepNumber: boolean) => void;
    numStages: number;
    setNumStages: (value: (((prevState: number) => number) | number)) => void;
    equityCapitalState: MoneyRange;
    setEquityCapitalState: (value: MoneyRange) => void;
    monthlyInvestState: MoneyRange;
    setMonthlyInvestState: (value: MoneyRange) => void;
    yourName: string;
    setYourName: (value: (((prevState: string) => string) | string)) => void;
    yourMail: string;
    setYourMail: (value: (((prevState: string) => string) | string)) => void;
    yourMobile: string;
    setYourMobile: (value: (((prevState: string) => string) | string)) => void;
    slideDirection: string;
    setSlideDirection: (value: (((prevState: string) => string) | string)) => void;
    source: string;
    setSource: (value: unknown) => void;
    selectedPath: string;
    setSelectedPath: (value: (((prevState: string) => string) | string)) => void;
    bundesland: string;
    setBundesland: (value: (((prevState: string) => string) | string)) => void;
    iidConsent: boolean;
    setIidConsent: (value: (((prevState: boolean) => boolean) | boolean)) => void;

}
export let InvestAssistantContext = createContext<InvestAssistantContextType | undefined>(undefined);

export function useInvestAssistantContext() {
    return useContext(InvestAssistantContext);
}